/**
 * Opakowanie szerokiej tabeli w panelu: gdy tabela się nie mieści, przewija się
 * sama tabela, nie cała strona.
 *
 * Samo `overflowX: 'auto'` nie wystarcza — w układzie flex/grid opakowanie
 * zgłasza rodzicom szerokość tabeli i rozpycha stronę (karta auta na prod,
 * 28.09.2026: strona 1382 px przy oknie 1366, przycisk „Dodaj wariant” ucięty).
 * `width: 0` + `minWidth: 100%` każe opakowaniu wziąć szerokość rodzica, a nie
 * treści — ten sam zabieg co w banku zleceń (`UserOfferList`).
 */
export const TABLE_SCROLL_SX = { overflowX: 'auto', width: 0, minWidth: '100%' } as const;
